export default "__VITE_ASSET__BbFOka$m__"